module.exports = {
  name: 'http-config',
  CORS: [],
  YQL: [],
}